// // Toast.js
// import React, { useState } from 'react';
// import { X } from 'lucide-react';

// export const useToast = () => {
//   const [toasts, setToasts] = useState([]);
  
//   const showToast = ({ message, type = 'success', duration = 5000 }) => {
//     const id = Date.now().toString();
//     setToasts(prev => [...prev, { id, message, type, duration }]);
    
//     setTimeout(() => {
//       setToasts(prev => prev.filter(toast => toast.id !== id));
//     }, duration);
    
//     return id;
//   };
  
//   const hideToast = (id) => {
//     setToasts(prev => prev.filter(toast => toast.id !== id));
//   };
  
//   const ToastContainer = () => (
//     <div className="fixed top-4 right-4 z-[9999] flex flex-col gap-2">
//       {toasts.map(toast => {
//         let bgColor = 'bg-gray-100 border-gray-500 text-gray-700';
        
//         switch(toast.type) {
//           case 'success':
//             bgColor = 'bg-green-100 border-green-500 text-green-700';
//             break;
//           case 'error':
//             bgColor = 'bg-red-100 border-red-500 text-red-700';
//             break;
//           case 'warning':
//             bgColor = 'bg-yellow-100 border-yellow-500 text-yellow-700';
//             break;
//           case 'info':
//             bgColor = 'bg-blue-100 border-blue-500 text-blue-700';
//             break;
//         }
        
//         return (
//           <div key={toast.id} className={`rounded-md border-l-4 p-4 shadow-md ${bgColor}`}>
//             <div className="flex items-center justify-between">
//               <p className="font-medium">{toast.message}</p>
//               <button 
//                 onClick={() => hideToast(toast.id)}
//                 className="ml-4 rounded-full p-1 hover:bg-black/10"
//               >
//                 <X className="h-4 w-4" />
//               </button>
//             </div>
//           </div>
//         );
//       })}
//     </div>
//   );
  
//   return { showToast, hideToast, ToastContainer };
// };

// Toast.js
import React, { useState, useEffect } from 'react';
import { X, CheckCircle, AlertCircle, AlertTriangle, Info } from 'lucide-react';

export const useToast = () => {
  const [toasts, setToasts] = useState([]);
  
  const showToast = ({ message, type = 'success', duration = 5000 }) => {
    const id = Date.now().toString();
    setToasts(prev => [...prev, { id, message, type, duration }]);
    
    setTimeout(() => {
      setToasts(prev => prev.filter(toast => toast.id !== id));
    }, duration);
    
    return id;
  };
  
  const hideToast = (id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  };
  
  const ToastContainer = () => (
    <div className="fixed top-4 right-4 z-[9999] flex flex-col gap-3 max-w-sm">
      {toasts.map(toast => {
        // Define styles and icons based on type
        let styles = '';
        let icon = null;
        
        switch(toast.type) {
          case 'success':
            styles = 'bg-green-50 border-green-500 text-green-800 shadow-lg shadow-green-100';
            icon = <CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0" />;
            break;
          case 'error':
            styles = 'bg-red-50 border-red-500 text-red-800 shadow-lg shadow-red-100';
            icon = <AlertCircle className="h-5 w-5 text-red-500 flex-shrink-0" />;
            break;
          case 'warning':
            styles = 'bg-yellow-50 border-yellow-500 text-yellow-800 shadow-lg shadow-yellow-100';
            icon = <AlertTriangle className="h-5 w-5 text-yellow-500 flex-shrink-0" />;
            break;
          case 'info':
            styles = 'bg-blue-50 border-blue-500 text-blue-800 shadow-lg shadow-blue-100';
            icon = <Info className="h-5 w-5 text-blue-500 flex-shrink-0" />;
            break;
          default:
            styles = 'bg-gray-50 border-gray-500 text-gray-800 shadow-lg shadow-gray-100';
            icon = <Info className="h-5 w-5 text-gray-500 flex-shrink-0" />;
        }
        
        return (
          <div 
            key={toast.id} 
            className={`rounded-lg border-l-4 p-4 animate-slide-in ${styles}`}
            style={{
              animation: 'slideIn 0.3s ease-out forwards',
              opacity: 0,
              transform: 'translateX(100%)'
            }}
          >
            <div className="flex items-start gap-3">
              {icon}
              <div className="flex-1">
                <p className="font-medium text-sm">{toast.message}</p>
              </div>
              <button 
                onClick={() => hideToast(toast.id)}
                className="ml-2 rounded-full p-1 hover:bg-black/10 flex-shrink-0"
                aria-label="Close"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
  
  // Add global style for animations if it doesn't exist
  useEffect(() => {
    const styleId = 'toast-animations';
    if (!document.getElementById(styleId)) {
      const styleElement = document.createElement('style');
      styleElement.id = styleId;
      styleElement.innerHTML = `
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateX(100%);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        
        @keyframes slideOut {
          from {
            opacity: 1;
            transform: translateX(0);
          }
          to {
            opacity: 0;
            transform: translateX(100%);
          }
        }
      `;
      document.head.appendChild(styleElement);
    }
    
    return () => {
      const element = document.getElementById(styleId);
      if (element) {
        document.head.removeChild(element);
      }
    };
  }, []);
  
  return { showToast, hideToast, ToastContainer };
};

export default useToast;